module.exports = __webpack_public_path__ + "static/Screenshot_2018-07-29_18-29-42.eb3dfa4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/sg-site/Screenshot_2018-07-29_18-29-42.png
// module id = 256
// module chunks = 35783957827783 246384609461072